import { useQuery } from '@apollo/client';
import { COMPANIES_INDUSTRIES_QUERY } from '@/graphql/queries';

const DEFAULT_ORDER = 'TOTAL';

type CompaniesIndustriesProps = {
  limit: number;
};

const useCompaniesIndustries = ({ limit = 4 }: CompaniesIndustriesProps) => {
  const { error, ...rest } = useQuery(COMPANIES_INDUSTRIES_QUERY, {
    variables: {
      limit,
      //@ts-ignore next-line
      order: DEFAULT_ORDER,
    },
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return {
    error,
    ...rest,
  };
};

export { useCompaniesIndustries, DEFAULT_ORDER };
